// BULK CONTACT ***********************************************************************************
// pathname: /v3/bulk-operation/contact/{jobSlug}
// ************************************************************************************************
import { useSwrMutationApi, ApiBulkContactApplicantsList, PostBulkBaseObject } from 'src/hooks/useSwrApi';


/**
 * @description Contacts the selected applicants.
 * - If all applicants are selected, use the 'buildListByStatus' parameter (back-end will ignore the 'slugs' array).
 *
 * @param jobSlug - the job slug
 * @param locale - the locale
 * @param successCallback - callback function to be executed on success
 *
 * @example
 * // contact all applicants with status 'interview' (3)
 * const { data, trigger } = useSwrBulkContact(jobSlug, 'ro');
 * trigger({ buildListByStatus: 3 });
 *
 * // contact selected applicants
 * trigger({ slugs: ['slug1', 'slug2'] });
 */
export const useSwrBulkContact = (jobSlug: string, locale: string = 'ro', successCallback?: () => void) => {
  const {
    data,
    error,
    trigger,
    isMutating,
    reset,
  } = useSwrMutationApi<ApiBulkContactApplicantsList, PostBulkBaseObject>({
    url: `/v3/bulk-operation/contact/${jobSlug}`,
    locale,
    fetcherConfig: {
      method: 'POST',
      stringifyPayload: true,
      headers: {
        'Content-Type': 'application/json',
      },
    },
    apiOptions: {
      onSuccess: () => {
        if (successCallback) successCallback();
      },
    },
    toastsOptions: {
      showSuccessToast: true,
      showErrorToast: true,
    },
  });

  // Return data
  return {
    data,
    error,
    trigger,
    isMutating,
    reset,
  };
};
